import { render, staticRenderFns } from "./DicionarioDadosHeader.vue?vue&type=template&id=1818e4bf"
import script from "./DicionarioDadosHeader.vue?vue&type=script&lang=js"
export * from "./DicionarioDadosHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports